"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const en_1 = __importDefault(require("./en"));
const currency_1 = require("../constants/currency");
const COMPANY_NAME = 'Roofoods Limited';
exports.default = Object.assign(Object.assign({}, en_1.default), { currency: currency_1.GBP, flags: { with: [COMPANY_NAME] } });
//# sourceMappingURL=en-GB.js.map